import {
  Button,
  HStack,
  Image,
  StackDivider,
  Text,
  VStack,
} from '@chakra-ui/react'
import { useWeb3React } from '@web3-react/core'
import { useTransactionContext } from 'contexts/TransactionContext'
import { ITransaction } from 'types'

import Transaction from './Transaction'

export const RecentTransactions = () => {
  const { account } = useWeb3React()
  const { transactions, clearTransactions } = useTransactionContext()
  if (!account || transactions.length === 0) {
    return (
      <VStack alignItems="center" justifyContent="center" pt={32}>
        <Image
          src={'/static/icons/handshake.svg'}
          w="60px"
          h="60px"
          alt={'Handshake'}
        />
        <Text
          fontWeight={'bold'}
          fontFamily={'mono'}
          color={'muted'}
          fontSize={'lg'}
        >
          No Transactions
        </Text>
      </VStack>
    )
  }
  return (
    <>
      <HStack justifyContent="space-between" alignItems="center" pb={2}>
        <Text fontFamily="mono" fontSize="xl">
          Recent Transactions
        </Text>
        <Button
          variant="ghost"
          colorScheme="blue"
          color="#2172e5"
          fontSize="sm"
          fontFamily="mono"
          onClick={clearTransactions}
          _focus={{ outline: 'none' }}
        >
          (clear all)
        </Button>
      </HStack>

      <VStack
        maxH={324}
        w="full"
        alignItems="stretch"
        pt={2}
        spacing={3}
        divider={<StackDivider borderColor="gray.900" />}
        overflowY="auto"
      >
        {transactions
          .sort(
            (a, b) =>
              (b.confirmedTime || b.addedTime) -
              (a.confirmedTime || a.addedTime)
          )
          .map((tx: ITransaction) => (
            <Transaction key={tx.txHash} {...tx} />
          ))}
      </VStack>
    </>
  )
}

export default RecentTransactions
